import transformButtons from 'libs/wordpress/utils/transformButtons';
import transformBackgroundImage from 'libs/wordpress/utils/transformBackgroundImage';
/**
 * Transforms data from text-section-repeater
 * @param {object[]} data - Array of text-section objects.
 * @param {object[]} - Transformed link data.
 */

export default data => {
    // Just return undefined if we don't have any data
    if (!data) {
        return undefined;
    }

    // Return the transformed data.
    return data.map(textSection => {
        const { layout } = textSection;
        if (layout === 'heading' || layout === 'sub_heading' || layout === 'sub-heading') {
            return {
                heading: textSection.heading.text,
                headingTag: textSection.heading.type,
                horizontalAlignment: textSection.horizontal_alignment,
                layout: layout === 'sub_heading' || layout === 'sub-heading' ? 'subHeading' : 'heading',
            };
        }
        if (layout === 'buttons') {
            return {
                buttons: transformButtons(textSection.buttons),
                horizontalAlignment: textSection.horizontal_alignment,
                layout: 'buttons',
            };
        }
        if (layout === 'image') {
            return {
                image: transformBackgroundImage(textSection.background_image),
                horizontalAlignment: textSection.horizontal_alignment,
                layout: 'image',
            };
        }

        // Layout === paragraph or preamble
        return {
            text: textSection['paragraph'],
            ...(layout === 'image' || layout === 'buttons') && textSection[layout],
            horizontalAlignment: textSection.horizontal_alignment,
            layout,
        };
    });
};
